import { useEffect, useState } from "react";
import Footer from "../../comps/Footer";
import Header from "../../comps/Header";
import { get_privacy_policy_data } from "../../api/Global";

const Privacy = () => {
      const [get_privacy_policy, set_privacy_policy] = useState({});

      useEffect(() => {
            const handle_get_privacy_policy = async () => {
                  try {
                        const response = await get_privacy_policy_data();
                        set_privacy_policy(response?.data?.data?.policies);
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_privacy_policy()
      }, [])

      // <-------- fetch the top on the page -------------->
      useEffect(() => {
            window.scrollTo(0, 0)
      }, [])
      return (
            <>
                  <Header />
                  <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                        <div className="relative">
                              <h1 className="text-5xl font-bold text-black mb-12 text-center">
                                    Privacy Policy
                              </h1>
                              <div className="space-y-12 text-white">
                                    <section className=" bg-[white]/95 text-black p-8 rounded-2xl border border-[#333438] hover:border-light-500 transition-all duration-300 backdrop-blur-sm">
                                          <h2 className="text-2xl font-bold theme_color mb-4 text-black">{get_privacy_policy?.title}</h2>
                                          <div className=" mb-4 privacy_terms text-gray-900" dangerouslySetInnerHTML={{ __html: get_privacy_policy?.content }}></div>
                                    </section>
                              </div>
                        </div>
                  </div>
                  <Footer />
            </>
      );
};

const sections = [
      {
            title: "1. Information Collection",
            description: "We gather the following types of information:",
            items: [
                  "Business details (name, address, registration information)",
                  "Personal details (name, contact information, identity verification)",
                  "Financial data (banking information, transaction records)",
                  "Technical information (IP address, browser details, device information)",
            ],
      },
      {
            title: "2. Use of Information",
            description: "We use the collected information to:",
            items: [
                  "Facilitate payments and process transactions",
                  "Ensure compliance with legal and regulatory obligations",
                  "Detect and prevent fraud and unauthorized actions",
                  "Enhance our services and overall user experience",
                  "Notify users of service updates and changes",
            ],
      },
      {
            title: "3. Data Security",
            description: "We employ strong security measures, including:",
            items: [
                  "Encryption of confidential data",
                  "Routine security audits and evaluations",
                  "Access restrictions and authentication protocols",
                  "Adherence to PCI DSS standards",
            ],
      },
      {
            title: "4. Data Sharing",
            description: "We may disclose information to:",
            items: [
                  "Payment processors and banking institutions",
                  "Regulatory bodies and law enforcement agencies",
                  "Fraud detection and verification services",
                  "Third-party service providers and business collaborators",
            ],
      },
      {
            title: "5. Data Retention",
            description: "We store data in compliance with:",
            items: [
                  "Applicable legal and regulatory obligations",
                  "Operational requirements of the business",
                  "Best practices in the industry",
            ],
      },
      {
            title: "6. User Rights",
            description: "Users are entitled to:",
            items: [
                  "View and access their personal information",
                  "Request corrections to or deletion of their data",
                  "Unsubscribe from marketing communications",
                  "Lodge complaints with regulatory authorities",
            ],
      },
      {
            title: "7. Updates to Privacy Policy",
            description: "We may revise this policy from time to time. Users will be informed of major changes via:",
            items: [
                  "Email alerts",
                  "Notices on the website",
                  "App modifications",
            ],
      },
];

export default Privacy;
